import { render, h } from 'preact';

import { getWorknetWidgetConfig } from '~/utils/config';
import Widget from '~/components/Widget';

import { getDeviceId } from './utils/deviceId';

import type { WorknetWidgetConfig } from '@worknet/models';

export default class WidgetHTMLElement extends HTMLElement {
  private shadowRootRef: ShadowRoot;

  constructor() {
    super();
    this.shadowRootRef = this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    if (this.shadowRootRef.querySelector('div')) {
      return;
    }
    const deviceId = getDeviceId();
    const widgetConfig = getWorknetWidgetConfig();

    const containerEl = document.createElement('div');
    const globalStyleEl = this.createGlobalStyleEl(widgetConfig);

    this.shadowRootRef.appendChild(globalStyleEl);
    this.shadowRootRef.appendChild(containerEl);

    const gooberEl = window._goober;
    this.shadowRootRef.appendChild(gooberEl!);

    render(h(Widget, { deviceId, widgetConfig, hostElement: this }), containerEl);
  }

  private createGlobalStyleEl({ styles }: WorknetWidgetConfig) {
    const globalStyle = document.createElement('style');
    const sideCss = styles.side === 'left' ? 'left: 24px;' : 'right: 24px;';

    globalStyle.textContent = `
        :host {
          display:block;
          position:fixed;
          ${sideCss}
          bottom: 24px;
          font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;

          z-index:var(--wn-z-index, ${styles.bubbleZIndex ?? styles.zIndex});

          --clr-primary: ${styles.primary};
          --clr-secondary: ${styles.secondary};
          --clr-tertiary: ${styles.tertiary};

          --button-side: ${styles.side};
      }

      *, *::before, *::after { box-sizing: border-box; }

      button { font-family: inherit; }
    `;

    return globalStyle;
  }
}
